export enum ViewType {
  Simple = 'simple',
  Detailed = 'detailed'
}
